// ...existing code...
import appraiserIntroductionTemplate from '../templates/PropertyContactRequest.html?raw';
import clientIntroductionTemplate from '../templates/ClientIntroduction.html?raw';
import clientIntroductionPVTemplate from '../templates/ClientIntroductionPV.html?raw';
import clientFollowUpTemplate from '../templates/ClientFollowUp.html?raw';
import propertyFollowUpTemplate from '../templates/PropertyFollowUp.html?raw';
import clientIntroductionPVAndJOTemplate from '../templates/ClientIntroductionPVAndJO.html?raw';

// Simple template engine for variable substitution
export function renderTemplate(templateString, data) {
  let rendered = templateString;

  // Replace simple {{variable}} patterns
  for (const [key, value] of Object.entries(data)) {
    const regex = new RegExp(`{{${key}}}`, 'g');
    rendered = rendered.replace(regex, value == null ? '' : String(value));
  }

  // Conditional blocks with else {{#if variable}}content{{else}}alternate{{/if}}
  rendered = rendered.replace(/{{#if\s+(\w+)}}([\s\S]*?)(?:{{else}}([\s\S]*?))?{{\/if}}/g, (match, variable, trueContent, falseContent) => {
    if (data[variable]) {
      return trueContent || '';
    } else {
      return falseContent || '';
    }
  });

  // Unless blocks {{#unless variable}}content{{/unless}}
  rendered = rendered.replace(/{{#unless\s+(\w+)}}([\s\S]*?){{\/unless}}/g, (match, variable, content) => {
    if (!data[variable]) {
      return content || '';
    } else {
      return '';
    }
  });

  return rendered;
}

// Export template strings
export const TEMPLATE_STRINGS = {
  'Property Contact Request': appraiserIntroductionTemplate,
  'Client Introduction': clientIntroductionTemplate,
  'Client Introduction PV': clientIntroductionPVTemplate,
  'Client Follow Up': clientFollowUpTemplate,
  'Property Follow Up': propertyFollowUpTemplate,
  'Client Introduction PV and JO': clientIntroductionPVAndJOTemplate
};

// Template metadata (add new expected vars)
export const TEMPLATE_METADATA = {
  'Property Contact Request': {
    name: 'Appraiser Introduction',
    description: 'Professional introduction email for property appraisal requests',
    requiredFields: [
      'clientName',
      'propertyAddress',
      'contactName',
      'fileId'
    ],
    optionalFields: [
      'propertyCounty',
      'proposedInspectionDate',
      'proposedInspectionTime',
      'senderName',
      'primaryValuer'
    ]
  }
};